import { Tweet } from '../types/tweet';
import useFetch from './useFetch';

const useTweets = (
  list: string
): {
  data: Tweet[];
  error: any;
  loading: boolean;
} => {
  return useFetch<Tweet[]>(`/api/twitter?list=${list}`);
};

export default useTweets;
